export { namespace } from "./actions";
import { ACTION_TYPES, Status } from './actions';

const initialState = {
  status: Status.INITIAL,
  data: []
}

export default function stationReducer(state = initialState, action) {
  switch (action.type) {

    case ACTION_TYPES.SET_STATION:
      {
        const { data } = action.payload;
        return {
          ...state,
          data
        }
      }

    case ACTION_TYPES.SET_STATUS:
      {
        const { status } = action.payload;
        return {
          ...state,
          status
        }
      }
    
      default:
        return state;
  }
}
